import * as React from 'react';
import type { PoiFeature } from '@ooh/ui/components/map-view';
import { PoiMarkerPopup } from '../components/poi-marker-popup';
import type { PoiFilterParams } from '../../../hooks/use-poi-filter-params';

interface UsePoiPopupRendererOptions {
  poiFeatures: PoiFeature[];
  selectedPoiCategory: string;
  setPoiFilterParams: (value: PoiFilterParams) => void;
  setSelectedPoiId: (id: string | null) => void;
}

export function usePoiPopupRenderer({
  poiFeatures,
  selectedPoiCategory,
  setPoiFilterParams,
  setSelectedPoiId,
}: UsePoiPopupRendererOptions): (poiId: string, onClose: () => void) => React.ReactNode {
  return React.useCallback(
    (poiId: string, onClose: () => void) => {
      const poi = poiFeatures.find((p) => p.id === poiId);
      if (!poi) return null;
      const handleSearchWithin = (poiId: string, radiusM: number) => {
        setPoiFilterParams({ nearPoiId: poiId, nearRadius: radiusM });
        onClose();
        setSelectedPoiId(null);
      };
      const handleClose = () => {
        onClose();
        setSelectedPoiId(null);
      };
      return (
        <PoiMarkerPopup
          poi={{
            id: poi.id,
            name: poi.name,
            brand: poi.brand,
            osm_key: poi.osm_key,
            osm_value: poi.osm_value,
          }}
          categoryLabel={selectedPoiCategory}
          onSearchWithin={handleSearchWithin}
          onClose={handleClose}
        />
      );
    },
    [poiFeatures, selectedPoiCategory, setPoiFilterParams, setSelectedPoiId],
  );
}
